import SavedQueryBaseRequest from "@/models/requests/savedQueries/SavedQueryBaseRequest";

export class GetMonthlyTmsExcYtdRequest extends SavedQueryBaseRequest {

    startDate: string;
    endDate: string;

    constructor(sendEmail = false, emails: string = null, startDate: string = null, endDate: string = null) {
        super(sendEmail, emails);

        this.startDate = startDate;
        this.endDate = endDate;
    }
}